import React from "react";
import PropTypes from "prop-types";
import { companyUrl } from "views_shared/app/javascript/utils/urls";
import SavedGroupsBookmark from "../../source_directory/SavedGroupsBookmark";
import HashtagPills from "../../source_directory/HashtagPills";
import LogoTile from "../../source_directory/LogoTile";
import HighlightAttribute, { highlightValue } from "../../source_directory/HighlightAttribute";
import BodyTextWithExpand from "../../feeds/BodyTextWithExpand";
import companyListActionColumnWidth from "./listActionColumn";

function CompanyCardList({ hit }) {
  const companyPath = companyUrl({ slug: hit.slug, migrate_id: hit.migrate_id });
  const description = hit.description || hit.headline || hit.experts_summary;
  // Only description and headline are searchable, so only those can carry a highlight; the
  // experts_summary fallback is shown plain.
  const descriptionAttribute = (hit.description && "description") || (hit.headline && "headline") || null;
  const hashtags = hit.hashtags || [];

  return (
    <div
      className="sd-list-row"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 16,
        padding: "12px 16px",
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
      }}
    >
      {/* Logo */}
      <LogoTile
        imageUrl={hit.profile_image_url}
        name={hit.name}
        size={44}
        borderRadius={8}
        fallbackBackground="#4f46e5"
        fallbackColor="#fff"
        fontSize={15}
        fontWeight={700}
      />

      {/* Name */}
      <div className="sd-list-row__col" style={{ flex: "0 0 180px", fontWeight: 700, fontSize: 14 }}>
        <a href={companyPath} style={{ color: "#111827" }}>
          <HighlightAttribute hit={hit} attribute="name" fallback={hit.name} />
        </a>
      </div>

      {/* Tags */}
      <div className="sd-list-row__col" style={{ flex: "0 0 260px", minWidth: 0 }}>
        {hashtags.length > 0 && <HashtagPills hashtags={hashtags} max={4} />}
      </div>

      {/* About */}
      <div className="sd-list-row__col" style={{ flex: 1, minWidth: 0, fontSize: 13, color: "#374151" }}>
        {description && (
          <BodyTextWithExpand
            body={description}
            maxLength={120}
            highlightValue={descriptionAttribute ? highlightValue(hit, descriptionAttribute) : undefined}
            textClassName=""
            textStyle={{ fontSize: 13, color: "#374151" }}
            toggleClassName="paragraph-xs"
          />
        )}
      </div>

      {/* Actions */}
      <div
        className="sd-list-row__col"
        style={{
          flex: `0 0 ${companyListActionColumnWidth()}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 12,
        }}
      >
        <a
          href={companyPath}
          className="btn btn-primary btn-sm"
          style={{ background: "#4f46e5", border: "none", borderRadius: 8 }}
        >
          Learn More
        </a>
        <SavedGroupsBookmark
          sourceableType="Id::PromoEntity::Company"
          sourceableId={hit.id}
          sourceMeta={{ name: hit.name, imageUrl: hit.profile_image_url, slug: hit.slug }}
        />
      </div>
    </div>
  );
}

CompanyCardList.propTypes = {
  hit: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    profile_image_url: PropTypes.string,
    description: PropTypes.string,
    headline: PropTypes.string,
    experts_summary: PropTypes.string,
    hashtags: PropTypes.arrayOf(
      PropTypes.shape({
        hashtag_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        hashtag_name: PropTypes.string,
        hashtag_slug: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default CompanyCardList;
